import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

class Description extends React.Component {
	render() {
		const { children: description } = this.props;
		return (
			// control-label ensures vertical alignment with other labels in
			// the group.
			<Row className="control-label">
				<Col sm={12} className="description">{description}</Col>
			</Row>
		);
	}
}

Description.propTypes = {
	children: PropTypes.any.isRequired
};

export default Description;
